.notice-strip__wrapper {
  .banner-area {
    max-height: 0;
    overflow: hidden;
  }

  .notice-strip {
    background: @ig-vivid-red;
    border: none;
    cursor: pointer;
    position: relative;
    min-height: 54px;
    display: flex;
    justify-content: center;
    margin: 0;
    padding: 0;
    width: 100%;
    z-index: 11;

    span {
      display: block;
      font-weight: 600;
      color: @white;
      text-align: center;
      line-height: 24px;
      max-width: 700px;
      font-size: 16px;
      margin: 11px 20px 19px;
    }

    &:after {
      content: '';
      width: 44px;
      height: 44px;
      background: @ig-vivid-red @plus-sign no-repeat center;
      border-radius: 22px;
      left: 50%;
      margin-left: -22px;
      position: absolute;
      display: block;
      bottom: -22px;
      transition: 0.3s transform ease-in;
      animation: 0.3s notice-strip-spin ease-in;
      z-index: 89;
    }

    &:hover,
    &:hover:after {
      background-color: @ig-red-700;
    }
    &:focus,
    &:focus:after {
      background-color: @ig-red-400;
    }

    &:hover:after {
      transform: rotate(90deg);
    }
  }

  & .banner-area {
    display: none;
  }

  &.expanded {
    .banner-area {
      max-height: 100%;
      display: block;
    }

    .notice-strip:after {
      background: @ig-vivid-red @minus-sign no-repeat center;
    }

    .notice-strip:focus,
    .notice-strip:focus:after {
      background-color: @ig-red-400;
    }

    .notice-strip:hover,
    .notice-strip:hover:after {
      background-color: @ig-red-600;
    }

    .notice-strip:hover:after {
      transform: none;
    }
  }
}

@keyframes notice-strip-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(-180deg);
  }
}

@animated_border_colour: @ig-red;
@animation_duration: 3s;
@animation_height: 300px;
@border_colour: gray;
@text_transition: bottom 0.5s ease-out;

@keyframes slide {
  to {
    bottom: 0;
  }
}
@keyframes slide-out {
  to {
    bottom: -100px;
  }
}

/* Set override class */
.notice-strip__wrapper--multi {
  .image-background div.c-hidden {
    border-top: 1px solid @border_colour;
  }
  .op-textAnimation {
    min-height: @animation_height;
    position: relative;
  }
}

.op-inText {
  position: absolute;
  transition: @text_transition;
  &.animated {
    animation-duration: @animation_duration;
    animation-name: slide;
  }
  &.animated-out {
    animation-duration: @animation_duration;
    animation-name: slide-out;
  }
  .simple-text p,
  .cta.section {
    opacity: 0;
    transition: opacity 0.5s ease-out;
  }
}
